import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { Banner } from "../../types/slices/bannersType";
import { useBannerStore } from "../../hooks/useBannerStore";
import { CreateEditBannerModal } from "./components/CreateEditBannerModal";

const columns = [
  { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "title", label: "TITULO", align: "center" },
  { type: "text", field: "description", label: "DESCRIPCIÓN", align: "start" },
  {
    type: "image",
    field: "image",
    label: "IMAGEN",
    align: "center",
    format: (row) =>
      row.image ? <img src={row.image} alt="logo" width="50px" /> : "",
  },
  { type: "text", field: "order", label: "ORDEN", align: "center" },
  {
    type: "text",
    field: "status",
    label: "ESTADO",
    format: (row) => (row.status ? "Activo" : "Inactivo"),
    align: "center",
  },
];

const BannersView: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [rowSelected, setRowSelected] = useState<Banner>({} as Banner);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    banners,
    statusBanners,
    openModal,
    getBanners,
    getBannersSearch,
    setSelectedBanner,
    deleteBanner,
    setOpenModal,
    setEditBanner,
    changeIsEdit,
  } = useBannerStore();

  useEffect(() => {
    setLoading(true);
    getBanners().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditBanner(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const onDeleteConfirm = async () => {
    const response = await deleteBanner(rowSelected?.id || 0);
    if (response === true) {
      setSelectedBanner({} as Banner);
      setModalDeleteConfirm(false);
      getBanners();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getBannersSearch(value);
    }
    if (value.length === 0) {
      getBanners();
    }
  };

  return (
    <>
      {statusBanners === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Portadas"}
          columns={columns}
          loading={loading}
          rows={banners || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={statusBanners}
        />
      )}
      {openModal && <CreateEditBannerModal />}
    </>
  );
};

export default BannersView;
